import { useCallback, useEffect, useState } from 'react'
import { apiAddListBankAccounts, apiAddListDevices, apiAddListInvoiceConfig, apiAddListInvoiceTemplateItems, apiAddListInvoiceTemplates, apiAddListPartnerConfig, apiAddListSannConfig, apiAddListTelesaleConfig, apiAddListTkgConfig, apiAddListTopUpConfig, apiAddListVersions, apiDeleteListInvoiceTemplateItems, apiDeleteListInvoiceTemplates, apiGetListBankAccounts, apiGetListCompanies, apiGetListDevices, apiGetListInvoiceConfig, apiGetListInvoiceTemplateItems, apiGetListInvoiceTemplates, apiGetListPartnerConfig, apiGetListSannConfig, apiGetListTelesaleConfig, apiGetListTkgConfig, apiGetListTopUpConfig, apiGetListUsers, apiGetListVersions, apiUpdateListBankAccounts, apiUpdateListDevices, apiUpdateListInvoiceConfig, apiUpdateListInvoiceTemplateItems, apiUpdateListInvoiceTemplates, apiUpdateListPartnerConfig, apiUpdateListSannConfig, apiUpdateListTelesaleConfig, apiUpdateListTkgConfig, apiUpdateListTopUpConfig, apiUpdateListVersions } from '../../api'
import { Button, Descriptions, Divider, Form, Input, InputNumber, Modal, Select, Space, Switch, TableProps, Tabs, Tag } from 'antd'
import { DeleteOutlined, EditOutlined, EyeOutlined, PlusOutlined } from '@ant-design/icons'
import CustomTable from '../../components/table'
import { formatDateTime } from '../../utils/entity-utils'
import defaultParams from '../../assets/constants/default_params'
import { ICompany } from '../../models/company.modal'
import { filterOptionByLabel } from '../../utils/filter-utils'
import { versionEnvOptions, versionStatusOptions } from '../../assets/constants/default_options'
import { useLoading } from '../../context/LoadingContext'
import { useSelector } from 'react-redux'
import { authSelector } from '../../redux/slices/authSlice'
import { toastError, toastSuccess } from '../../utils/toast'
import { IUser } from '../../models/user.model'
import { renderProductNature } from '../kit-sim/order'
import { formatCurrency } from '../../utils/string-utils'

export default function ConfigPage() {
    const [companyOptions, setCompanyOptions] = useState<{ label: string, value: Number }[]>([])
    const [userOptions, setUserOptions] = useState<{ label: string, value: Number }[]>([])
    const [invoiceTemplates, setInvoiceTemplates] = useState<any>({})
    const [invoiceTemplateItems, setInvoiceTemplateItems] = useState<any>({})
    const [telesaleConfig, setTelesaleConfig] = useState<any>({})
    const [devices, setDevices] = useState<any>({})
    const [versions, setVersions] = useState<any>({})
    const [bankAccounts, setBankAccounts] = useState<any>({})
    const [partnerConfig, setPartnerConfig] = useState<any>({})
    const [topUpConfig, setTopUpConfig] = useState<any>({})
    const [invoiceConfig, setInvoiceConfig] = useState<any>({})
    const [tkgConfig, setTkgConfig] = useState<any>({})
    const [sannConfig, setSannConfig] = useState<any>({})
    const [modalCreateInvoiceTemplateItems, setModalCreateInvoiceTemplateItems] = useState({ isOpen: false, invoice_template_id: 0 })
    const [isOpenModalCreateInvoiceTemplates, setIsOpenModalCreateInvoiceTemplates] = useState(false)
    const [isOpenModalCreateTelesaleConfig, setTsOpenModalCreateTelesaleConfig] = useState(false)
    const [isOpenModalCreateDevice, setTsOpenModalCreateDevice] = useState(false)
    const [isOpenModalCreateVersion, setTsOpenModalCreateVersion] = useState(false)
    const [isOpenModalCreateBankAccount, setTsOpenModalCreateBankAccount] = useState(false)
    const [isOpenModalCreatePartnerConfig, setTsOpenModalCreatePartnerConfig] = useState(false)
    const [isOpenModalCreateTopUpConfig, setTsOpenModalCreateTopUpConfig] = useState(false)
    const [isOpenModalCreateInvoiceConfig, setTsOpenModalCreateInvoiceConfig] = useState(false)
    const [isOpenModalCreateTkgConfig, setTsOpenModalCreateTkgConfig] = useState(false)
    const [isOpenModalCreateSannConfig, setTsOpenModalCreateSannConfig] = useState(false)
    const [modalUpdateInvoiceTemplateItems, setModalUpdateInvoiceTemplateItems] = useState<any>({ isOpen: false, data: null })
    const [modalUpdateInvoiceTemplates, setModalUpdateInvoiceTemplates] = useState<any>({ isOpen: false, data: null })
    const [modalDeleteInvoiceTemplates, setModalDeleteInvoiceTemplates] = useState<any>({ isOpen: false, data: null })
    const [modalDeleteInvoiceTemplateItems, setModalDeleteInvoiceTemplateItems] = useState<any>({ isOpen: false, data: null })
    const [modalUpdateTelesaleConfig, setModalUpdateTelesaleConfig] = useState<any>({ isOpen: false, data: null })
    const [modalUpdateDevice, setModalUpdateDevice] = useState<any>({ isOpen: false, data: null })
    const [modalUpdateVersion, setModalUpdateVersion] = useState<any>({ isOpen: false, data: null })
    const [modalUpdateBankAccount, setModalUpdateBankAccount] = useState<any>({ isOpen: false, data: null })
    const [modalUpdatePartnerConfig, setModalUpdatePartnerConfig] = useState<any>({ isOpen: false, data: null })
    const [modalUpdateTopUpConfig, setModalUpdateTopUpConfig] = useState<any>({ isOpen: false, data: null })
    const [modalUpdateInvoiceConfig, setModalUpdateInvoiceConfig] = useState<any>({ isOpen: false, data: null })
    const [modalUpdateTkgConfig, setModalUpdateTkgConfig] = useState<any>({ isOpen: false, data: null })
    const [modalUpdateSannConfig, setModalUpdateSannConfig] = useState<any>({ isOpen: false, data: null })
    const [modalDetailInvoiceTemplates, setModalDetailInvoiceTemplates] = useState<any>({ isOpen: false, data: null })
    const [formCreateInvoiceTemplateItems] = Form.useForm()
    const [formCreateInvoiceTemplates] = Form.useForm()
    const [formCreateTelesaleConfig] = Form.useForm()
    const [formCreateDevice] = Form.useForm()
    const [formCreateVersion] = Form.useForm()
    const [formCreateBankAccount] = Form.useForm()
    const [formCreatePartnerConfig] = Form.useForm()
    const [formCreateTopUpConfig] = Form.useForm()
    const [formCreateInvoiceConfig] = Form.useForm()
    const [formCreateTkgConfig] = Form.useForm()
    const [formCreateSannConfig] = Form.useForm()
    const [formUpdateInvoiceTemplateItems] = Form.useForm()
    const [formUpdateInvoiceTemplates] = Form.useForm()
    const [formUpdateTelesaleConfig] = Form.useForm()
    const [formUpdateDevice] = Form.useForm()
    const [formUpdateVersion] = Form.useForm()
    const [formUpdateBankAccount] = Form.useForm()
    const [formUpdatePartnerConfig] = Form.useForm()
    const [formUpdateTopUpConfig] = Form.useForm()
    const [formUpdateInvoiceConfig] = Form.useForm()
    const [formUpdateTkgConfig] = Form.useForm()
    const [formUpdateSannConfig] = Form.useForm()
    const { setIsLoading } = useLoading()
    const { account } = useSelector(authSelector)

    const invoiceTemplatesColumns: TableProps<any>['columns'] = [
        {
            key: 'cpCode',
            title: 'Đối tác',
            dataIndex: 'cpCode',
        },
        {
            key: 'alias',
            title: 'Tên template',
            dataIndex: 'alias',
        },
        {
            key: 'tran_amount',
            title: 'Số tiền giao dịch',
            dataIndex: 'tran_amount',
            render: tran_amount => formatCurrency(tran_amount),
        },
        {
            key: 'total_amount',
            title: 'Tổng số tiền',
            dataIndex: 'total_amount',
            render: total_amount => formatCurrency(total_amount),
        },
        {
            key: 'tax_rate',
            title: 'Thuế suất',
            dataIndex: 'tax_rate',
            render: tax_rate => tax_rate + '%',
        },
        {
            key: 'invoice_series',
            title: 'Mẫu số',
            dataIndex: 'invoice_series',
        },
        {
            key: 'currency_code',
            title: 'Loại tiền tệ',
            dataIndex: 'currency_code',
        },
        {
            key: 'exchange_rate',
            title: 'Tỷ giá',
            dataIndex: 'exchange_rate',
        },
        {
            key: 'payment_method_name',
            title: 'Hình thức thanh toán',
            dataIndex: 'payment_method_name',
        },
        {
            key: 'network',
            title: 'Network',
            dataIndex: 'network',
        },
        {
            key: 'customer_address',
            title: 'Địa chỉ khách hàng',
            dataIndex: 'customer_address',
        },
        {
            key: 'updated_at',
            title: 'Cập nhật',
            dataIndex: 'updated_at',
            render: updatedAt => formatDateTime(updatedAt),
        },
        {
            key: 'action',
            title: 'Tác vụ',
            render: (_, data: any) => (
                <Space>
                    <Button
                        onClick={() => {
                            setModalDetailInvoiceTemplates({ isOpen: true, data })
                        }}
                        style={{ background: '#9a29b6', color: 'white' }}
                        icon={<EyeOutlined />}
                    />
                    <Button
                        onClick={() => {
                            setModalCreateInvoiceTemplateItems({ isOpen: true, invoice_template_id: data.id })
                        }}
                        style={{ background: '#0ea40d', color: 'white' }}
                        icon={<PlusOutlined />}
                    />
                    <Button
                        onClick={() => {
                            setModalUpdateInvoiceTemplates({ isOpen: true, data })
                            formUpdateInvoiceTemplates.setFieldsValue(data)
                        }}
                        style={{ background: '#b07a16', color: 'white' }}
                        icon={<EditOutlined />}
                    />
                    <Button
                        onClick={() => {
                            setModalDeleteInvoiceTemplates({ isOpen: true, data })
                        }}
                        style={{ background: '#ff4d4f', color: 'white' }}
                        icon={<DeleteOutlined />}
                    />
                </Space>
            ),
        },
    ]

    const invoiceTemplateItemsColumns: TableProps<any>['columns'] = [
        {
            key: 'product_line_number',
            title: 'STT',
            dataIndex: 'product_line_number',
        },
        {
            key: 'description',
            title: 'Tên hàng hoá',
            dataIndex: 'description',
        },
        {
            key: 'unit',
            title: 'Đơn vị',
            dataIndex: 'unit',
        },
        {
            key: 'quantity',
            title: 'Số lượng',
            dataIndex: 'quantity',
        },
        {
            key: 'unit_price',
            title: 'Đơn giá',
            dataIndex: 'unit_price',
            render: unit_price => formatCurrency(unit_price),
        },
        {
            key: 'product_nature',
            title: 'Loại sản phẩm',
            dataIndex: 'product_nature',
            render: product_nature => renderProductNature(product_nature),
        },
        {
            key: 'updated_at',
            title: 'Cập nhật',
            dataIndex: 'updated_at',
            render: updatedAt => formatDateTime(updatedAt),
        },
        {
            key: 'action',
            title: 'Tác vụ',
            render: (_, data: any) => (
                <Space>
                    <Button
                        onClick={() => {
                            setModalUpdateInvoiceTemplateItems({ isOpen: true, data })
                            formUpdateInvoiceTemplateItems.setFieldsValue(data)
                        }}
                        style={{ background: '#b07a16', color: 'white' }}
                        icon={<EditOutlined />}
                    />
                    <Button
                        onClick={() => {
                            setModalDeleteInvoiceTemplateItems({ isOpen: true, data })
                        }}
                        style={{ background: '#ff4d4f', color: 'white' }}
                        icon={<DeleteOutlined />}
                    />
                </Space>
            ),
        },
    ]

    const telesaleConfigColumns: TableProps<any>['columns'] = [
        {
            key: 'ownerBy',
            title: 'Nhân sự',
            dataIndex: 'ownerBy',
        },
        {
            key: 'displayName',
            title: 'Tên hiển thị',
            dataIndex: 'displayName',
        },
        {
            key: 'isHidden',
            title: 'Bị ẩn',
            dataIndex: 'isHidden',
            render: isHidden => isHidden && 'Có',
        },
        {
            key: 'result',
            title: 'Mô tả',
            dataIndex: 'result',
        },
        {
            key: 'updatedAt',
            title: 'Cập nhật',
            dataIndex: 'updatedAt',
            render: updatedAt => formatDateTime(updatedAt),
        },
        {
            key: 'action',
            title: 'Tác vụ',
            render: (_, data: any) => (
                <Button
                    onClick={() => {
                        setModalUpdateTelesaleConfig({ isOpen: true, data })
                        formUpdateTelesaleConfig.setFieldsValue(data)
                    }}
                    style={{ background: '#b07a16', color: 'white' }}
                >
                    Cập nhật
                </Button>
            ),
        },
    ]

    const deviceColumns: TableProps<any>['columns'] = [
        {
            key: 'cpCode',
            title: 'Đối tác',
            dataIndex: 'cpCode',
        },
        {
            key: 'serialSim',
            title: 'Serial Sim',
            dataIndex: 'serialSim',
        },
        {
            key: 'deviceId',
            title: 'Mã thiết bị',
            dataIndex: 'deviceId',
        },
        {
            key: 'fcmToken',
            title: 'FCM Token',
            dataIndex: 'fcmToken',
        },
        {
            key: 'updated_at',
            title: 'Cập nhật',
            dataIndex: 'updated_at',
            render: updatedAt => formatDateTime(updatedAt),
        },
        {
            key: 'action',
            title: 'Tác vụ',
            render: (_, data: any) => (
                <Button
                    onClick={() => {
                        setModalUpdateDevice({ isOpen: true, data })
                        formUpdateDevice.setFieldsValue(data)
                    }}
                    style={{ background: '#b07a16', color: 'white' }}
                >
                    Cập nhật
                </Button>
            ),
        },
    ]

    const versionColumns: TableProps<any>['columns'] = [
        {
            key: 'cpCode',
            title: 'Đối tác',
            dataIndex: 'cpCode',
        },
        {
            key: 'platform',
            title: 'Nền tảng',
            dataIndex: 'platform',
        },
        {
            key: 'store',
            title: 'Cửa hàng',
            dataIndex: 'store',
        },
        {
            key: 'version_code',
            title: 'Phiên bản',
            dataIndex: 'version_code',
        },
        {
            key: 'status',
            title: 'Trạng thái',
            dataIndex: 'status',
        },
        {
            key: 'pandora_config_path',
            title: 'Đường dẫn pandora',
            dataIndex: 'pandora_config_path',
        },
        {
            key: 'env',
            title: 'Môi trường',
            dataIndex: 'env',
        },
        {
            key: 'base_url',
            title: 'Đường dẫn',
            dataIndex: 'base_url',
        },
        {
            key: 'base_url_ws',
            title: 'Đường dẫn WebSocket',
            dataIndex: 'base_url_ws',
        },
        {
            key: 'description',
            title: 'Mô tả',
            dataIndex: 'description',
        },
        {
            key: 'updated_at',
            title: 'Cập nhật',
            dataIndex: 'updated_at',
            render: updatedAt => formatDateTime(updatedAt),
        },
        {
            key: 'action',
            title: 'Tác vụ',
            render: (_, data: any) => (
                <Button
                    onClick={() => {
                        setModalUpdateVersion({ isOpen: true, data })
                        formUpdateVersion.setFieldsValue(data)
                    }}
                    style={{ background: '#b07a16', color: 'white' }}
                >
                    Cập nhật
                </Button>
            ),
        },
    ]

    const bankAccountColumns: TableProps<any>['columns'] = [
        {
            key: 'cpCode',
            title: 'Đối tác',
            dataIndex: 'cpCode',
        },
        {
            key: 'ownerBy',
            title: 'Nhân sự',
            dataIndex: 'ownerBy',
        },
        {
            key: 'bankName',
            title: 'Ngân hàng',
            dataIndex: 'bankName',
        },
        {
            key: 'accountNumber',
            title: 'Số tài khoản',
            dataIndex: 'accountNumber',
        },
        {
            key: 'accountName',
            title: 'Tên chủ tài khoản',
            dataIndex: 'accountName',
        },
        {
            key: 'result',
            title: 'Mô tả',
            dataIndex: 'result',
        },
        {
            key: 'updatedAt',
            title: 'Cập nhật',
            dataIndex: 'updatedAt',
            render: updatedAt => formatDateTime(updatedAt),
        },
        {
            key: 'action',
            title: 'Tác vụ',
            render: (_, data: any) => (
                <Button
                    onClick={() => {
                        setModalUpdateBankAccount({ isOpen: true, data })
                        formUpdateBankAccount.setFieldsValue(data)
                    }}
                    style={{ background: '#b07a16', color: 'white' }}
                >
                    Cập nhật
                </Button>
            ),
        },
    ]

    const partnerConfigColumns: TableProps<any>['columns'] = [
        {
            key: 'cpCode',
            title: 'Đối tác',
            dataIndex: 'cpCode',
        },
        {
            key: 'ownerBy',
            title: 'Nhân sự',
            dataIndex: 'ownerBy',
        },
        {
            key: 'password',
            title: 'Mật khẩu',
            dataIndex: 'password',
        },
        {
            key: 'secretKey',
            title: 'Secret Key',
            dataIndex: 'secretKey',
        },
        {
            key: 'permissions',
            title: 'Quyền hạn',
            dataIndex: 'permissions',
            render: (permissions: string) => {
                if (!permissions) return '-';
                return <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                    {permissions.split('\n').map((line: string, index: number) => (
                        <Tag key={index}>{line}</Tag>
                    ))}
                </div>;
            },
        },
        {
            key: 'result',
            title: 'Mô tả',
            dataIndex: 'result',
        },
        {
            key: 'updatedAt',
            title: 'Cập nhật',
            dataIndex: 'updatedAt',
            render: updatedAt => formatDateTime(updatedAt),
        },
        {
            key: 'action',
            title: 'Tác vụ',
            render: (_, data: any) => (
                <Button
                    onClick={() => {
                        setModalUpdatePartnerConfig({ isOpen: true, data })
                        formUpdatePartnerConfig.setFieldsValue(data)
                    }}
                    style={{ background: '#b07a16', color: 'white' }}
                >
                    Cập nhật
                </Button>
            ),
        },
    ]

    const topUpConfigColumns: TableProps<any>['columns'] = [
        {
            key: 'cpCode',
            title: 'Đối tác',
            dataIndex: 'cpCode',
        },
        {
            key: 'ownerBy',
            title: 'Nhân sự',
            dataIndex: 'ownerBy',
        },
        {
            key: 'network',
            title: 'Tên mạng',
            dataIndex: 'network',
        },
        {
            key: 'username',
            title: 'Tài khoản',
            dataIndex: 'username',
        },
        {
            key: 'password',
            title: 'Mật khẩu',
            dataIndex: 'password',
        },
        {
            key: 'userId',
            title: 'userId',
            dataIndex: 'userId',
        },
        {
            key: 'rsaPrivateKeyPath',
            title: 'rsaPrivateKeyPath',
            dataIndex: 'rsaPrivateKeyPath',
        },
        {
            key: 'result',
            title: 'Mô tả',
            dataIndex: 'result',
        },
        {
            key: 'updatedAt',
            title: 'Cập nhật',
            dataIndex: 'updatedAt',
            render: updatedAt => formatDateTime(updatedAt),
        },
        {
            key: 'action',
            title: 'Tác vụ',
            render: (_, data: any) => (
                <Button
                    onClick={() => {
                        setModalUpdateTopUpConfig({ isOpen: true, data })
                        formUpdateTopUpConfig.setFieldsValue(data)
                    }}
                    style={{ background: '#b07a16', color: 'white' }}
                >
                    Cập nhật
                </Button>
            ),
        },
    ]

    const invoiceConfigColumns: TableProps<any>['columns'] = [
        {
            key: 'cpCode',
            title: 'Đối tác',
            dataIndex: 'cpCode',
        },
        {
            key: 'provider',
            title: 'Nhà cung cấp',
            dataIndex: 'provider',
        },
        {
            key: 'network',
            title: 'Tên mạng',
            dataIndex: 'network',
        },
        {
            key: 'username',
            title: 'Tài khoản',
            dataIndex: 'username',
        },
        {
            key: 'password',
            title: 'Mật khẩu',
            dataIndex: 'password',
        },
        {
            key: 'baseUrl',
            title: 'Base URL',
            dataIndex: 'baseUrl',
        },
        {
            key: 'grantType',
            title: 'Grant Type',
            dataIndex: 'grantType',
        },
        {
            key: 'taxCode',
            title: 'Tax Code',
            dataIndex: 'taxCode',
        },
        {
            key: "templateCode",
            title: "Template Code",
            dataIndex: "templateCode"
        },
        {
            key: 'result',
            title: 'Mô tả',
            dataIndex: 'result',
        },
        {
            key: 'updatedAt',
            title: 'Cập nhật',
            dataIndex: 'updatedAt',
            render: updatedAt => formatDateTime(updatedAt),
        },
        {
            key: 'action',
            title: 'Tác vụ',
            render: (_, data: any) => (
                <Button
                    onClick={() => {
                        setModalUpdateInvoiceConfig({ isOpen: true, data })
                        formUpdateInvoiceConfig.setFieldsValue(data)
                    }}
                    style={{ background: '#b07a16', color: 'white' }}
                >
                    Cập nhật
                </Button>
            ),
        },
    ]

    const tkgConfigColumns: TableProps<any>['columns'] = [
        {
            key: 'cpCode',
            title: 'Đối tác',
            dataIndex: 'cpCode',
        },
        {
            key: 'ownerBy',
            title: 'Nhân sự',
            dataIndex: 'ownerBy',
        },
        {
            key: 'network',
            title: 'Tên mạng',
            dataIndex: 'network',
        },
        {
            key: 'username',
            title: 'Tài khoản',
            dataIndex: 'username',
        },
        {
            key: 'password',
            title: 'Mật khẩu',
            dataIndex: 'password',
        },
        {
            key: 'secretKey',
            title: 'secretKey',
            dataIndex: 'secretKey',
        },
        {
            key: 'devStaffCode',
            title: 'devStaffCode',
            dataIndex: 'devStaffCode',
        },
        {
            key: 'result',
            title: 'Mô tả',
            dataIndex: 'result',
        },
        {
            key: 'updatedAt',
            title: 'Cập nhật',
            dataIndex: 'updatedAt',
            render: updatedAt => formatDateTime(updatedAt),
        },
        {
            key: 'action',
            title: 'Tác vụ',
            render: (_, data: any) => (
                <Button
                    onClick={() => {
                        setModalUpdateTkgConfig({ isOpen: true, data })
                        formUpdateTkgConfig.setFieldsValue(data)
                    }}
                    style={{ background: '#b07a16', color: 'white' }}
                >
                    Cập nhật
                </Button>
            ),
        },
    ]

    const sannConfigColumns: TableProps<any>['columns'] = [
        {
            key: 'cpCode',
            title: 'Đối tác',
            dataIndex: 'cpCode',
        },
        {
            key: 'ownerBy',
            title: 'Nhân sự',
            dataIndex: 'ownerBy',
        },
        {
            key: 'network',
            title: 'Tên mạng',
            dataIndex: 'network',
        },
        {
            key: 'baseUrl',
            title: 'Base URL',
            dataIndex: 'baseUrl',
        },
        {
            key: 'proxyAddresses',
            title: 'Proxy Addresses',
            dataIndex: 'proxyAddresses',
            render: (proxyAddresses: string) => {
                if (!proxyAddresses) return '-';
                return <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                    {proxyAddresses.split(',').map((proxy: string, index: number) => (
                        <Tag key={index}>{proxy.trim()}</Tag>
                    ))}
                </div>;
            },
        },
        {
            key: 'result',
            title: 'Mô tả',
            dataIndex: 'result',
        },
        {
            key: 'updatedAt',
            title: 'Cập nhật',
            dataIndex: 'updatedAt',
            render: updatedAt => formatDateTime(updatedAt),
        },
        {
            key: 'action',
            title: 'Tác vụ',
            render: (_, data: any) => (
                <Button
                    onClick={() => {
                        setModalUpdateSannConfig({ isOpen: true, data })
                        formUpdateSannConfig.setFieldsValue(data)
                    }}
                    style={{ background: '#b07a16', color: 'white' }}
                >
                    Cập nhật
                </Button>
            ),
        },
    ]

    const fetchOptions = useCallback(async () => {
        try {
            const [respUser, respCompany] = await Promise.all([
                apiGetListUsers({
                    limit: defaultParams.MAX_LIMIT,
                }),
                apiGetListCompanies({
                    limit: defaultParams.MAX_LIMIT,
                }),
            ])
            if (respUser.data?.users) {
                const userOptions = respUser.data.users
                    .map((item: IUser) => ({
                        label: item.username,
                        value: item.username,
                    }))
                setUserOptions(userOptions)
            }
            if (respCompany.data?.companies) {
                const compOptions = respCompany.data.companies
                    .map((item: ICompany) => ({
                        label: item.name,
                        value: item.code,
                    }))
                setCompanyOptions(compOptions)
            }
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchInvoiceTemplateItems = useCallback(async () => {
        try {
            const { data } = await apiGetListInvoiceTemplateItems({ orderBy: 'created_at' })
            setInvoiceTemplateItems(data)
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchInvoiceTemplates = useCallback(async () => {
        try {
            const { data } = await apiGetListInvoiceTemplates({ orderBy: 'created_at' })
            setInvoiceTemplates(data)
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchTelesaleConfig = useCallback(async () => {
        try {
            const { data } = await apiGetListTelesaleConfig({})
            setTelesaleConfig(data)
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchDevices = useCallback(async () => {
        try {
            const { data } = await apiGetListDevices({ orderBy: 'created_at' })
            setDevices(data)
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchVersions = useCallback(async () => {
        try {
            const { data } = await apiGetListVersions({ orderBy: 'created_at' })
            setVersions(data)
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchPartnerConfig = useCallback(async () => {
        try {
            const { data } = await apiGetListPartnerConfig({})
            setPartnerConfig(data)
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchBankAccounts = useCallback(async () => {
        try {
            const { data } = await apiGetListBankAccounts({})
            setBankAccounts(data)
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchTopUpConfig = useCallback(async () => {
        try {
            const { data } = await apiGetListTopUpConfig({})
            setTopUpConfig(data)
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchInvoiceConfig = useCallback(async () => {
        try {
            const { data } = await apiGetListInvoiceConfig({})
            setInvoiceConfig(data)
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchTkgConfig = useCallback(async () => {
        try {
            const { data } = await apiGetListTkgConfig({})
            setTkgConfig(data)
        } catch (error) {
            console.log(error)
        }
    }, [])

    const fetchSannConfig = useCallback(async () => {
        try {
            const { data } = await apiGetListSannConfig({})
            setSannConfig(data)
        } catch (error) {
            console.log(error)
        }
    }, [])

    useEffect(() => {
        fetchOptions()
        fetchInvoiceTemplateItems()
        fetchInvoiceTemplates()
        fetchTelesaleConfig()
        fetchDevices()
        fetchVersions()
        fetchPartnerConfig()
        fetchBankAccounts()
        fetchTopUpConfig()
        fetchInvoiceConfig()
        fetchTkgConfig()
        fetchSannConfig()
    }, [fetchOptions, fetchInvoiceTemplates, fetchTelesaleConfig, fetchDevices, fetchPartnerConfig, fetchVersions, fetchBankAccounts, fetchTopUpConfig, fetchInvoiceConfig, fetchTkgConfig, fetchSannConfig])

    const handleCreateInvoiceTemplates = async (values: any) => {
        try {
            setIsLoading(true)
            await apiAddListInvoiceTemplates({
                templates: [values]
            })
            setIsOpenModalCreateInvoiceTemplates(false)
            fetchInvoiceTemplates()
            formCreateInvoiceTemplates.resetFields()
            toastSuccess('Thêm template hóa đơn thành công!')
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }

    const handleCreateInvoiceTemplateItems = async (values: any) => {
        try {
            setIsLoading(true)
            await apiAddListInvoiceTemplateItems({ items: [{ ...values, invoice_template_id: modalCreateInvoiceTemplateItems.invoice_template_id }] })
            setModalCreateInvoiceTemplateItems({ isOpen: false, invoice_template_id: 0 })
            fetchInvoiceTemplateItems()
            formCreateInvoiceTemplateItems.resetFields()
            toastSuccess('Thêm template-item hóa đơn thành công!')
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }

    const handleCreateTelesaleConfig = async (values: any) => {
        try {
            setIsLoading(true)
            await apiAddListTelesaleConfig({ telesales: [values] })
            setTsOpenModalCreateTelesaleConfig(false)
            fetchTelesaleConfig()
            formCreateTelesaleConfig.resetFields()
            toastSuccess('Thêm cấu hình telesale thành công!')
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }

    const handleCreateDevice = async (values: any) => {
        try {
            setIsLoading(true)
            await apiAddListDevices({ devices: [values] })
            setTsOpenModalCreateDevice(false)
            fetchDevices()
            formCreateDevice.resetFields()
            toastSuccess('Thêm phiên bản thành công!')
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }

    const handleCreateVersion = async (values: any) => {
        try {
            setIsLoading(true)
            await apiAddListVersions({ versions: [values] })
            setTsOpenModalCreateVersion(false)
            fetchVersions()
            formCreateVersion.resetFields()
            toastSuccess('Thêm phiên bản thành công!')
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }

    const handleCreateBankAccount = async (values: any) => {
        try {
            setIsLoading(true)
            await apiAddListBankAccounts({ bankAccounts: [values] })
            setTsOpenModalCreateBankAccount(false)
            fetchBankAccounts()
            formCreateBankAccount.resetFields()
            toastSuccess('Thêm tài khoản ngân hàng thành công!')
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }

    const handleCreatePartnerConfig = async (values: any) => {
        try {
            setIsLoading(true)
            await apiAddListPartnerConfig({ partners: [values] })
            setTsOpenModalCreatePartnerConfig(false)
            fetchPartnerConfig()
            formCreatePartnerConfig.resetFields()
            toastSuccess('Thêm cấu hình MBH thành công!')
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }

    const handleCreateTopUpConfig = async (values: any) => {
        try {
            setIsLoading(true)
            await apiAddListTopUpConfig({ topUpConfigs: [values] })
            setTsOpenModalCreateTopUpConfig(false)
            fetchTopUpConfig()
            formCreateTopUpConfig.resetFields()
            toastSuccess('Thêm tài khoản nạp tiền thành công!')
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }

    const handleCreateInvoiceConfig = async (values: any) => {
        try {
            setIsLoading(true)
            await apiAddListInvoiceConfig({ invoiceConfigs: [values] })
            setTsOpenModalCreateInvoiceConfig(false)
            fetchInvoiceConfig()
            formCreateInvoiceConfig.resetFields()
            toastSuccess('Thêm cấu hình hoá đơn thành công!')
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }

    const handleCreateTkgConfig = async (values: any) => {
        try {
            setIsLoading(true)
            await apiAddListTkgConfig({ tkgConfigs: [values] })
            setTsOpenModalCreateTkgConfig(false)
            fetchTkgConfig()
            formCreateTkgConfig.resetFields()
            toastSuccess('Thêm tài khoản API gói thành công!')
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }

    const handleCreateSannConfig = async (values: any) => {
        try {
            setIsLoading(true)
            await apiAddListSannConfig({ configs: [values] })
            setTsOpenModalCreateSannConfig(false)
            fetchSannConfig()
            formCreateSannConfig.resetFields()
            toastSuccess('Thêm cấu hình SANN thành công!')
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }

    const handleUpdateInvoiceTemplateItems = async (values: any) => {
        try {
            setIsLoading(true)
            await apiUpdateListInvoiceTemplateItems({ items: [values] })
            setModalUpdateInvoiceTemplateItems({ isOpen: false, data: null })
            fetchInvoiceTemplateItems()
            toastSuccess('Cập nhật template-item hóa đơn thành công!')
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }

    const handleUpdateInvoiceTemplates = async (values: any) => {
        try {
            setIsLoading(true)
            await apiUpdateListInvoiceTemplates({
                templates: [values]
            })
            setModalUpdateInvoiceTemplates({ isOpen: false, data: null })
            fetchInvoiceTemplates()
            toastSuccess('Cập nhật template hóa đơn thành công!')
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }

    const handleUpdateTelesaleConfig = async (values: any) => {
        try {
            setIsLoading(true)
            await apiUpdateListTelesaleConfig({ telesales: [values] })
            setModalUpdateTelesaleConfig({ isOpen: false, data: null })
            fetchTelesaleConfig()
            toastSuccess('Cập nhật cấu hình telesale thành công!')
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }

    const handleUpdateDevice = async (values: any) => {
        try {
            setIsLoading(true)
            await apiUpdateListDevices({ devices: [values] })
            setModalUpdateDevice({ isOpen: false, data: null })
            fetchDevices()
            toastSuccess('Cập nhật phiên bản thành công!')
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }

    const handleUpdateVersion = async (values: any) => {
        try {
            setIsLoading(true)
            await apiUpdateListVersions({ versions: [values] })
            setModalUpdateVersion({ isOpen: false, data: null })
            fetchVersions()
            toastSuccess('Cập nhật phiên bản thành công!')
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }

    const handleUpdateBankAccount = async (values: any) => {
        try {
            setIsLoading(true)
            await apiUpdateListBankAccounts({ bankAccounts: [values] })
            setModalUpdateBankAccount({ isOpen: false, data: null })
            fetchBankAccounts()
            toastSuccess('Cập nhật tài khoản ngân hàng thành công!')
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }

    const handleUpdatePartnerConfig = async (values: any) => {
        try {
            setIsLoading(true)
            await apiUpdateListPartnerConfig({ partners: [values] })
            setModalUpdatePartnerConfig({ isOpen: false, data: null })
            fetchPartnerConfig()
            toastSuccess('Cập nhật cấu hình MBH thành công!')
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }

    const handleUpdateTopUpConfig = async (values: any) => {
        try {
            setIsLoading(true)
            await apiUpdateListTopUpConfig({ topUpConfigs: [values] })
            setModalUpdateTopUpConfig({ isOpen: false, data: null })
            fetchTopUpConfig()
            toastSuccess('Cập nhật tài khoản nạp tiền thành công!')
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }

    const handleUpdateInvoiceConfig = async (values: any) => {
        try {
            setIsLoading(true)
            await apiUpdateListInvoiceConfig({ invoiceConfigs: [values] })
            setModalUpdateInvoiceConfig({ isOpen: false, data: null })
            fetchInvoiceConfig()
            toastSuccess('Cập nhật cấu hình hoá đơn thành công!')
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }

    const handleUpdateTkgConfig = async (values: any) => {
        try {
            setIsLoading(true)
            await apiUpdateListTkgConfig({ tkgConfigs: [values] })
            setModalUpdateTkgConfig({ isOpen: false, data: null })
            fetchTkgConfig()
            toastSuccess('Cập nhật tài khoản API gói thành công!')
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }

    const handleUpdateSannConfig = async (values: any) => {
        try {
            setIsLoading(true)
            await apiUpdateListSannConfig({ configs: [values] })
            setModalUpdateSannConfig({ isOpen: false, data: null })
            fetchSannConfig()
            toastSuccess('Cập nhật cấu hình SANN thành công!')
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }

    const handleDeleteInvoiceTemplates = async () => {
        try {
            setIsLoading(true)
            await apiDeleteListInvoiceTemplates({ templates: [modalDeleteInvoiceTemplates.data] })
            setModalDeleteInvoiceTemplates({ isOpen: false, data: null })
            fetchInvoiceTemplates()
            toastSuccess('Xoá template hóa đơn thành công!')
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }

    const handleDeleteInvoiceTemplateItems = async () => {
        try {
            setIsLoading(true)
            await apiDeleteListInvoiceTemplateItems({ items: [modalDeleteInvoiceTemplateItems.data] })
            setModalDeleteInvoiceTemplateItems({ isOpen: false, data: null })
            fetchInvoiceTemplateItems()
            toastSuccess('Xoá template-item hóa đơn thành công!')
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div>
            <Tabs
                size='middle'
                defaultActiveKey="invoiceTemplates"
                items={[
                    {
                        key: 'invoiceTemplates',
                        label: 'Template Hoá đơn',
                        disabled: !account?.canGetListInvoiceTemplates,
                        children: (
                            <div>
                                {account?.canGetListInvoiceTemplates && (
                                    <div style={{ textAlign: 'right', marginBottom: '20px' }}>
                                        <Button onClick={() => setIsOpenModalCreateInvoiceTemplates(true)}>
                                            Thêm template
                                        </Button>
                                    </div>
                                )}
                                <CustomTable
                                    namePage='template'
                                    columns={invoiceTemplatesColumns}
                                    dataSource={invoiceTemplates?.templates}
                                    total={invoiceTemplates?.total}
                                    isHiddenPagination={true}
                                />
                                <Modal
                                    title='Thêm template hóa đơn'
                                    open={isOpenModalCreateInvoiceTemplates}
                                    footer={null}
                                    onCancel={() => setIsOpenModalCreateInvoiceTemplates(false)}>
                                    <Divider />
                                    <Form form={formCreateInvoiceTemplates} onFinish={handleCreateInvoiceTemplates} layout="vertical" autoComplete='off'>
                                        <Form.Item name='cpCode' label='Công ty'
                                            rules={[{ required: true, message: 'Vui lòng chọn công ty!' }]}>
                                            <Select
                                                showSearch
                                                placeholder="Chọn công ty"
                                                options={companyOptions}
                                                filterOption={filterOptionByLabel}
                                            />
                                        </Form.Item>
                                        <Form.Item name='alias' label='Tên template'
                                            rules={[{ required: true, message: 'Vui lòng nhập tên template!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='tran_amount' label='Số tiền giao dịch'>
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                        <Form.Item name='total_amount' label='Tổng số tiền'
                                            rules={[{ required: true, message: 'Vui lòng nhập tổng số tiền!' }]}>
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                        <Form.Item name='tax_rate' label='Thuế suất'
                                            rules={[{ required: true, message: 'Vui lòng nhập thuế suất!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='invoice_series' label='Mẫu số'
                                            rules={[{ required: true, message: 'Vui lòng nhập mẫu số!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='currency_code' label='Loại tiền tệ'
                                            rules={[{ required: true, message: 'Vui lòng nhập loại tiền tệ!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='exchange_rate' label='Tỷ giá'
                                            rules={[{ required: true, message: 'Vui lòng nhập tỷ giá!' }]}>
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                        <Form.Item name='payment_method_name' label='Hình thức thanh toán'
                                            rules={[{ required: true, message: 'Vui lòng nhập hình thức thanh toán!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='network' label='Network'
                                            rules={[{ required: true, message: 'Vui lòng nhập Network!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='customer_address' label='Địa chỉ khách hàng'>
                                            <Input />
                                        </Form.Item>
                                        <div style={{ textAlign: 'right' }}>
                                            <Button type='primary' htmlType='submit'>Thêm</Button>
                                        </div>
                                    </Form>
                                </Modal>
                                <Modal
                                    title='Cập nhật template hóa đơn'
                                    open={modalUpdateInvoiceTemplates.isOpen}
                                    footer={null}
                                    onCancel={() => setModalUpdateInvoiceTemplates({ isOpen: false, data: null })}>
                                    <Divider />
                                    <Form form={formUpdateInvoiceTemplates} onFinish={handleUpdateInvoiceTemplates} layout="vertical" autoComplete='off'>
                                        <Form.Item style={{ display: 'none' }} name='id' />
                                        <Form.Item name='cpCode' label='Công ty'
                                            rules={[{ required: true, message: 'Vui lòng chọn công ty!' }]}>
                                            <Select
                                                showSearch
                                                placeholder="Chọn công ty"
                                                options={companyOptions}
                                                filterOption={filterOptionByLabel}
                                            />
                                        </Form.Item>
                                        <Form.Item name='alias' label='Tên template'
                                            rules={[{ required: true, message: 'Vui lòng nhập tên template!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='tran_amount' label='Số tiền giao dịch'>
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                        <Form.Item name='total_amount' label='Tổng số tiền'
                                            rules={[{ required: true, message: 'Vui lòng nhập tổng số tiền!' }]}>
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                        <Form.Item name='tax_rate' label='Thuế suất'
                                            rules={[{ required: true, message: 'Vui lòng nhập thuế suất!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='invoice_series' label='Mẫu số'
                                            rules={[{ required: true, message: 'Vui lòng nhập mẫu số!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='currency_code' label='Loại tiền tệ'
                                            rules={[{ required: true, message: 'Vui lòng nhập loại tiền tệ!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='exchange_rate' label='Tỷ giá'
                                            rules={[{ required: true, message: 'Vui lòng nhập tỷ giá!' }]}>
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                        <Form.Item name='payment_method_name' label='Hình thức thanh toán'
                                            rules={[{ required: true, message: 'Vui lòng nhập hình thức thanh toán!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='network' label='Network'
                                            rules={[{ required: true, message: 'Vui lòng nhập Network!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='customer_address' label='Địa chỉ khách hàng'>
                                            <Input />
                                        </Form.Item>
                                        <div style={{ textAlign: 'right' }}>
                                            <Button type='primary' htmlType='submit'>Cập nhật</Button>
                                        </div>
                                    </Form>
                                </Modal>
                                <Modal
                                    title='Xoá template hóa đơn'
                                    open={modalDeleteInvoiceTemplates.isOpen}
                                    footer={null}
                                    onCancel={() => setModalDeleteInvoiceTemplates({ isOpen: false, data: null })}>
                                    <Divider />
                                    Bạn có chắc muốn xoá <b>{modalDeleteInvoiceTemplates.data?.cpCode}</b> giá <b>{formatCurrency(modalDeleteInvoiceTemplates.data?.total_amount)}</b>?
                                    <div style={{ textAlign: 'right' }}>
                                        <Button type='primary' danger onClick={handleDeleteInvoiceTemplates}>Xoá</Button>
                                    </div>
                                </Modal>
                                <Modal
                                    width={'64%'}
                                    title='Chi tiết template hóa đơn'
                                    open={modalDetailInvoiceTemplates.isOpen}
                                    footer={null}
                                    onCancel={() => setModalDetailInvoiceTemplates({ isOpen: false, data: null })}>
                                    <Divider />
                                    <Descriptions
                                        items={[
                                            {
                                                key: 'cpCode',
                                                label: 'Đối tác',
                                                children: modalDetailInvoiceTemplates.data?.cpCode,
                                            },
                                            {
                                                key: 'network',
                                                label: 'Network',
                                                children: modalDetailInvoiceTemplates.data?.network,
                                            },
                                            {
                                                key: 'invoice_series',
                                                label: 'Mẫu số',
                                                children: modalDetailInvoiceTemplates.data?.invoice_series,
                                            },
                                            {
                                                key: 'tran_amount',
                                                label: 'Số tiền giao dịch',
                                                children: formatCurrency(modalDetailInvoiceTemplates.data?.tran_amount),
                                            },
                                            {
                                                key: 'total_amount',
                                                label: 'Tổng số tiền',
                                                children: formatCurrency(modalDetailInvoiceTemplates.data?.total_amount),
                                            },
                                            {
                                                key: 'tax_rate',
                                                label: 'Thuế suất',
                                                children: modalDetailInvoiceTemplates.data?.tax_rate + '%',
                                            },
                                            {
                                                key: 'currency_code',
                                                label: 'Loại tiền tệ',
                                                children: modalDetailInvoiceTemplates.data?.currency_code,
                                            },
                                            {
                                                key: 'exchange_rate',
                                                label: 'Tỷ giá',
                                                children: modalDetailInvoiceTemplates.data?.exchange_rate,
                                            },
                                            {
                                                key: 'payment_method_name',
                                                label: 'Hình thức thanh toán',
                                                children: modalDetailInvoiceTemplates.data?.payment_method_name,
                                            },
                                            {
                                                key: 'alias',
                                                label: 'Tên template',
                                                children: modalDetailInvoiceTemplates.data?.alias,
                                            },
                                            {
                                                key: 'customer_address',
                                                label: 'Địa chỉ khách hàng',
                                                children: modalDetailInvoiceTemplates.data?.customer_address,
                                            }
                                        ]}
                                    />
                                    <CustomTable
                                        namePage='sản phẩm'
                                        columns={invoiceTemplateItemsColumns}
                                        dataSource={invoiceTemplateItems?.items?.filter((i: any) => i.invoice_template_id === modalDetailInvoiceTemplates.data?.id)}
                                        total={invoiceTemplateItems?.items?.filter((i: any) => i.invoice_template_id === modalDetailInvoiceTemplates.data?.id)?.length}
                                        isHiddenPagination={true}
                                    />
                                </Modal>
                                <Modal
                                    title='Thêm template item hóa đơn'
                                    open={modalCreateInvoiceTemplateItems.isOpen}
                                    footer={null}
                                    onCancel={() => setModalCreateInvoiceTemplateItems({ isOpen: false, invoice_template_id: 0 })}>
                                    <Divider />
                                    <Form form={formCreateInvoiceTemplateItems} onFinish={handleCreateInvoiceTemplateItems} layout="vertical" autoComplete='off'>
                                        <Form.Item name='product_line_number' label='Số thứ tự (0001, 0002, ...)'
                                            rules={[{ required: true, message: 'Vui lòng nhập Số thứ tự!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='description' label='Tên hàng hoá'
                                            rules={[{ required: true, message: 'Vui lòng nhập tên hàng hoá!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='unit' label='Đơn vị'
                                            rules={[{ required: true, message: 'Vui lòng nhập đơn vị!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='quantity' label='Số lượng'
                                            rules={[{ required: true, message: 'Vui lòng nhập số lượng!' }]}>
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                        <Form.Item name='unit_price' label='Đơn giá'
                                            rules={[{ required: true, message: 'Vui lòng nhập đơn giá!' }]}>
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                        <Form.Item name='product_nature' label='Chọn loại hàng hoá'
                                            rules={[{ required: true, message: 'Vui lòng chọn loại hàng hoá!' }]}>
                                            <Select>
                                                <Select.Option value={1}>Hàng hóa dịch vụ</Select.Option>
                                                <Select.Option value={2}>Khuyến mại</Select.Option>
                                                <Select.Option value={3}>Chiết khấu thương mại</Select.Option>
                                                <Select.Option value={4}>Ghi chú/ diễn giải</Select.Option>
                                                <Select.Option value={5}>Hàng hóa đăc trưng</Select.Option>
                                            </Select>
                                        </Form.Item>
                                        <div style={{ textAlign: 'right' }}>
                                            <Button type='primary' htmlType='submit'>Thêm</Button>
                                        </div>
                                    </Form>
                                </Modal>
                                <Modal
                                    title='Cập nhật template item hóa đơn'
                                    open={modalUpdateInvoiceTemplateItems.isOpen}
                                    footer={null}
                                    onCancel={() => setModalUpdateInvoiceTemplateItems({ isOpen: false, invoice_template_id: 0 })}>
                                    <Divider />
                                    <Form form={formUpdateInvoiceTemplateItems} onFinish={handleUpdateInvoiceTemplateItems} layout="vertical" autoComplete='off'>
                                        <Form.Item style={{ display: 'none' }} name='id' />
                                        <Form.Item style={{ display: 'none' }} name='invoice_template_id' />
                                        <Form.Item name='product_line_number' label='Số thứ tự (0001, 0002, ...)'
                                            rules={[{ required: true, message: 'Vui lòng nhập Số thứ tự!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='description' label='Tên hàng hoá'
                                            rules={[{ required: true, message: 'Vui lòng nhập tên hàng hoá!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='unit' label='Đơn vị'
                                            rules={[{ required: true, message: 'Vui lòng nhập đơn vị!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='quantity' label='Số lượng'
                                            rules={[{ required: true, message: 'Vui lòng nhập số lượng!' }]}>
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                        <Form.Item name='unit_price' label='Đơn giá'
                                            rules={[{ required: true, message: 'Vui lòng nhập đơn giá!' }]}>
                                            <InputNumber style={{ width: '100%' }} />
                                        </Form.Item>
                                        <Form.Item name='product_nature' label='Chọn loại hàng hoá'
                                            rules={[{ required: true, message: 'Vui lòng chọn loại hàng hoá!' }]}>
                                            <Select>
                                                <Select.Option value={1}>Hàng hóa dịch vụ</Select.Option>
                                                <Select.Option value={2}>Khuyến mại</Select.Option>
                                                <Select.Option value={3}>Chiết khấu thương mại</Select.Option>
                                                <Select.Option value={4}>Ghi chú/ diễn giải</Select.Option>
                                                <Select.Option value={5}>Hàng hóa đăc trưng</Select.Option>
                                            </Select>
                                        </Form.Item>
                                        <div style={{ textAlign: 'right' }}>
                                            <Button type='primary' htmlType='submit'>Cập nhật</Button>
                                        </div>
                                    </Form>
                                </Modal>
                                <Modal
                                    title='Xoá template item hóa đơn'
                                    open={modalDeleteInvoiceTemplateItems.isOpen}
                                    footer={null}
                                    onCancel={() => setModalDeleteInvoiceTemplateItems({ isOpen: false, data: null })}>
                                    <Divider />
                                    Bạn có chắc muốn xoá <b>{modalDeleteInvoiceTemplateItems.data?.description}</b> giá <b>{formatCurrency(modalDeleteInvoiceTemplateItems.data?.unit_price)}</b>?
                                    <div style={{ textAlign: 'right' }}>
                                        <Button type='primary' danger onClick={handleDeleteInvoiceTemplateItems}>Xoá</Button>
                                    </div>
                                </Modal>
                            </div>
                        ),
                    },
                    {
                        key: 'telesaleConfig',
                        label: 'Cấu hình telesale',
                        disabled: !account?.canGetListTelesaleConfig,
                        children: (
                            <div>
                                {account?.canAddListTelesaleConfig && (
                                    <div style={{ textAlign: 'right', marginBottom: '20px' }}>
                                        <Button onClick={() => setTsOpenModalCreateTelesaleConfig(true)}>
                                            Thêm cấu hình
                                        </Button>
                                    </div>
                                )}
                                <CustomTable
                                    namePage='cấu hình'
                                    columns={telesaleConfigColumns}
                                    dataSource={telesaleConfig?.telesales}
                                    total={telesaleConfig?.total}
                                    isHiddenPagination={true}
                                />
                                <Modal
                                    title='Thêm cấu hình telesale'
                                    open={isOpenModalCreateTelesaleConfig}
                                    footer={null}
                                    onCancel={() => setTsOpenModalCreateTelesaleConfig(false)}>
                                    <Divider />
                                    <Form form={formCreateTelesaleConfig} onFinish={handleCreateTelesaleConfig} layout="vertical" autoComplete='off'>
                                        <Form.Item name='ownerBy' label='Nhân sự'
                                            rules={[{ required: true, message: 'Vui lòng chọn nhân sự!' }]}>
                                            <Select
                                                showSearch
                                                placeholder="Chọn nhân sự"
                                                options={userOptions}
                                                filterOption={filterOptionByLabel}
                                            />
                                        </Form.Item>
                                        <Form.Item name='displayName' label='Tên hiển thị'
                                            rules={[{ required: true, message: 'Vui lòng nhập tên hiển thị!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='result' label='Mô tả'>
                                            <Input />
                                        </Form.Item>
                                        <div style={{ textAlign: 'right' }}>
                                            <Button type='primary' htmlType='submit'>Thêm</Button>
                                        </div>
                                    </Form>
                                </Modal>
                                <Modal
                                    title='Cập nhật cấu hình telesale'
                                    open={modalUpdateTelesaleConfig.isOpen}
                                    footer={null}
                                    onCancel={() => setModalUpdateTelesaleConfig({ isOpen: false, data: null })}>
                                    <Divider />
                                    <Form form={formUpdateTelesaleConfig} onFinish={handleUpdateTelesaleConfig} layout="vertical" autoComplete='off'>
                                        <Form.Item style={{ display: 'none' }} name='sk' />
                                        <Form.Item name='ownerBy' label='Nhân sự'
                                            rules={[{ required: true, message: 'Vui lòng chọn nhân sự!' }]}>
                                            <Select
                                                showSearch
                                                placeholder="Chọn nhân sự"
                                                options={userOptions}
                                                filterOption={filterOptionByLabel}
                                            />
                                        </Form.Item>
                                        <Form.Item name='displayName' label='Tên hiển thị'
                                            rules={[{ required: true, message: 'Vui lòng nhập tên hiển thị!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item label="Bị ẩn" name="isHidden" valuePropName="checked">
                                            <Switch checkedChildren="Có" unCheckedChildren="Không" />
                                        </Form.Item>
                                        <Form.Item name='result' label='Mô tả'>
                                            <Input />
                                        </Form.Item>
                                        <div style={{ textAlign: 'right' }}>
                                            <Button type='primary' htmlType='submit'>Cập nhật</Button>
                                        </div>
                                    </Form>
                                </Modal>
                            </div>
                        ),
                    },
                    {
                        key: 'devices',
                        label: 'Thiết bị',
                        disabled: !account?.canGetListDevices,
                        children: (
                            <div>
                                {account?.canAddListDevices && (
                                    <div style={{ textAlign: 'right', marginBottom: '20px' }}>
                                        <Button onClick={() => setTsOpenModalCreateDevice(true)}>
                                            Thêm thiết bị
                                        </Button>
                                    </div>
                                )}
                                <CustomTable
                                    namePage='thiết bị'
                                    columns={deviceColumns}
                                    dataSource={devices?.devices}
                                    total={devices?.total}
                                    isHiddenPagination={true}
                                />
                                <Modal
                                    title='Thêm thiết bị'
                                    open={isOpenModalCreateDevice}
                                    footer={null}
                                    onCancel={() => setTsOpenModalCreateDevice(false)}>
                                    <Divider />
                                    <Form form={formCreateDevice} onFinish={handleCreateDevice} layout="vertical" autoComplete='off'>
                                        <Form.Item name='cpCode' label='Công ty'
                                            rules={[{ required: true, message: 'Vui lòng chọn công ty!' }]}>
                                            <Select
                                                showSearch
                                                placeholder="Chọn công ty"
                                                options={companyOptions}
                                                filterOption={filterOptionByLabel}
                                            />
                                        </Form.Item>
                                        <Form.Item name='serialSim' label='Serial Sim'
                                            rules={[{ required: true, message: 'Vui lòng nhập serial sim!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='deviceId' label='Mã thiết bị'
                                            rules={[{ required: true, message: 'Vui lòng nhập mã thiết bị!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='fcmToken' label='FCM Token'
                                            rules={[{ required: true, message: 'Vui lòng nhập FCM Token!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <div style={{ textAlign: 'right' }}>
                                            <Button type='primary' htmlType='submit'>Thêm</Button>
                                        </div>
                                    </Form>
                                </Modal>
                                <Modal
                                    title='Cập nhật thiết bị'
                                    open={modalUpdateDevice.isOpen}
                                    footer={null}
                                    onCancel={() => setModalUpdateDevice({ isOpen: false, data: null })}>
                                    <Divider />
                                    <Form form={formUpdateDevice} onFinish={handleUpdateDevice} layout="vertical" autoComplete='off'>
                                        <Form.Item style={{ display: 'none' }} name='id' />
                                        <Form.Item name='cpCode' label='Công ty'
                                            rules={[{ required: true, message: 'Vui lòng chọn công ty!' }]}>
                                            <Select
                                                showSearch
                                                placeholder="Chọn công ty"
                                                options={companyOptions}
                                                filterOption={filterOptionByLabel}
                                            />
                                        </Form.Item>
                                        <Form.Item name='serialSim' label='Serial Sim'
                                            rules={[{ required: true, message: 'Vui lòng nhập serial sim!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='deviceId' label='Mã thiết bị'
                                            rules={[{ required: true, message: 'Vui lòng nhập mã thiết bị!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='fcmToken' label='FCM Token'
                                            rules={[{ required: true, message: 'Vui lòng nhập FCM Token!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <div style={{ textAlign: 'right' }}>
                                            <Button type='primary' htmlType='submit'>Cập nhật</Button>
                                        </div>
                                    </Form>
                                </Modal>
                            </div>
                        ),
                    },
                    {
                        key: 'versions',
                        label: 'Phiên bản',
                        disabled: !account?.canGetListVersions,
                        children: (
                            <div>
                                {account?.canAddListVersions && (
                                    <div style={{ textAlign: 'right', marginBottom: '20px' }}>
                                        <Button onClick={() => setTsOpenModalCreateVersion(true)}>
                                            Thêm phiên bản
                                        </Button>
                                    </div>
                                )}
                                <CustomTable
                                    namePage='phiên bản'
                                    columns={versionColumns}
                                    dataSource={versions?.versions}
                                    total={versions?.total}
                                    isHiddenPagination={true}
                                />
                                <Modal
                                    title='Thêm phiên bản'
                                    open={isOpenModalCreateVersion}
                                    footer={null}
                                    onCancel={() => setTsOpenModalCreateVersion(false)}>
                                    <Divider />
                                    <Form form={formCreateVersion} onFinish={handleCreateVersion} layout="vertical" autoComplete='off'>
                                        <Form.Item name='cpCode' label='Công ty'
                                            rules={[{ required: true, message: 'Vui lòng chọn công ty!' }]}>
                                            <Select
                                                showSearch
                                                placeholder="Chọn công ty"
                                                options={companyOptions}
                                                filterOption={filterOptionByLabel}
                                            />
                                        </Form.Item>
                                        <Form.Item name='platform' label='Nền tảng'
                                            rules={[{ required: true, message: 'Vui lòng nhập nền tảng!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='store' label='Cửa hàng'
                                            rules={[{ required: true, message: 'Vui lòng nhập cửa hàng!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='version_code' label='Phiên bản'
                                            rules={[{ required: true, message: 'Vui lòng nhập phiên bản!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='status' label='Trạng thái'
                                            rules={[{ required: true, message: 'Vui lòng chọn trạng thái!' }]}>
                                            <Select
                                                placeholder="Chọn trạng thái"
                                                options={versionStatusOptions}
                                            />
                                        </Form.Item>
                                        <Form.Item name='pandora_config_path' label='Đường dẫn pandora'
                                            rules={[{ required: true, message: 'Vui lòng nhập đường dẫn pandora!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='env' label='Môi trường'
                                            rules={[{ required: true, message: 'Vui lòng chọn môi trường!' }]}>
                                            <Select
                                                placeholder="Chọn môi trường"
                                                options={versionEnvOptions}
                                            />
                                        </Form.Item>
                                        <Form.Item name='base_url' label='Đường dẫn'
                                            rules={[{ required: true, message: 'Vui lòng nhập đường dẫn!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='base_url_ws' label='Đường dẫn WebSocket'
                                            rules={[{ required: true, message: 'Vui lòng nhập đường dẫn WebSocket!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='description' label='Mô tả'>
                                            <Input />
                                        </Form.Item>
                                        <div style={{ textAlign: 'right' }}>
                                            <Button type='primary' htmlType='submit'>Thêm</Button>
                                        </div>
                                    </Form>
                                </Modal>
                                <Modal
                                    title='Cập nhật phiên bản'
                                    open={modalUpdateVersion.isOpen}
                                    footer={null}
                                    onCancel={() => setModalUpdateVersion({ isOpen: false, data: null })}>
                                    <Divider />
                                    <Form form={formUpdateVersion} onFinish={handleUpdateVersion} layout="vertical" autoComplete='off'>
                                        <Form.Item style={{ display: 'none' }} name='id' />
                                        <Form.Item name='cpCode' label='Công ty'
                                            rules={[{ required: true, message: 'Vui lòng chọn công ty!' }]}>
                                            <Select
                                                showSearch
                                                placeholder="Chọn công ty"
                                                options={companyOptions}
                                                filterOption={filterOptionByLabel}
                                            />
                                        </Form.Item>
                                        <Form.Item name='platform' label='Nền tảng'
                                            rules={[{ required: true, message: 'Vui lòng nhập nền tảng!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='store' label='Cửa hàng'
                                            rules={[{ required: true, message: 'Vui lòng nhập cửa hàng!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='version_code' label='Phiên bản'
                                            rules={[{ required: true, message: 'Vui lòng nhập phiên bản!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='status' label='Trạng thái'
                                            rules={[{ required: true, message: 'Vui lòng chọn trạng thái!' }]}>
                                            <Select
                                                placeholder="Chọn trạng thái"
                                                options={versionStatusOptions}
                                            />
                                        </Form.Item>
                                        <Form.Item name='pandora_config_path' label='Đường dẫn pandora'
                                            rules={[{ required: true, message: 'Vui lòng nhập đường dẫn pandora!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='env' label='Môi trường'
                                            rules={[{ required: true, message: 'Vui lòng chọn môi trường!' }]}>
                                            <Select
                                                placeholder="Chọn môi trường"
                                                options={versionEnvOptions}
                                            />
                                        </Form.Item>
                                        <Form.Item name='base_url' label='Đường dẫn'
                                            rules={[{ required: true, message: 'Vui lòng nhập đường dẫn!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='base_url_ws' label='Đường dẫn WebSocket'
                                            rules={[{ required: true, message: 'Vui lòng nhập đường dẫn WebSocket!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='description' label='Mô tả'>
                                            <Input />
                                        </Form.Item>
                                        <div style={{ textAlign: 'right' }}>
                                            <Button type='primary' htmlType='submit'>Cập nhật</Button>
                                        </div>
                                    </Form>
                                </Modal>
                            </div>
                        ),
                    },
                    {
                        key: 'bankAccounts',
                        label: 'Tài khoản ngân hàng',
                        disabled: !account?.canGetListBankAccounts,
                        children: (
                            <div>
                                {account?.canAddListBankAccounts && (
                                    <div style={{ textAlign: 'right', marginBottom: '20px' }}>
                                        <Button onClick={() => setTsOpenModalCreateBankAccount(true)}>
                                            Thêm tài khoản
                                        </Button>
                                    </div>
                                )}
                                <CustomTable
                                    namePage='tài khoản'
                                    columns={bankAccountColumns}
                                    dataSource={bankAccounts?.bankAccounts}
                                    total={bankAccounts?.total}
                                    isHiddenPagination={true}
                                />
                                <Modal
                                    title='Thêm tài khoản ngân hàng'
                                    open={isOpenModalCreateBankAccount}
                                    footer={null}
                                    onCancel={() => setTsOpenModalCreateBankAccount(false)}>
                                    <Divider />
                                    <Form form={formCreateBankAccount} onFinish={handleCreateBankAccount} layout="vertical" autoComplete='off'>
                                        <Form.Item name='cpCode' label='Công ty'
                                            rules={[{ required: true, message: 'Vui lòng chọn công ty!' }]}>
                                            <Select
                                                showSearch
                                                placeholder="Chọn công ty"
                                                options={companyOptions}
                                                filterOption={filterOptionByLabel}
                                            />
                                        </Form.Item>
                                        <Form.Item name='bankName' label='Tên ngân hàng'
                                            rules={[{ required: true, message: 'Vui lòng nhập tên ngân hàng!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='accountNumber' label='Số tài khoản'
                                            rules={[{ required: true, message: 'Vui lòng nhập số tài khoản!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='accountName' label='Tên chủ tài khoản'
                                            rules={[{ required: true, message: 'Vui lòng nhập tên chủ tài khoản!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='result' label='Mô tả'>
                                            <Input />
                                        </Form.Item>
                                        <div style={{ textAlign: 'right' }}>
                                            <Button type='primary' htmlType='submit'>Thêm</Button>
                                        </div>
                                    </Form>
                                </Modal>
                                <Modal
                                    title='Cập nhật tài khoản ngân hàng'
                                    open={modalUpdateBankAccount.isOpen}
                                    footer={null}
                                    onCancel={() => setModalUpdateBankAccount({ isOpen: false, data: null })}>
                                    <Divider />
                                    <Form form={formUpdateBankAccount} onFinish={handleUpdateBankAccount} layout="vertical" autoComplete='off'>
                                        <Form.Item style={{ display: 'none' }} name='sk' />
                                        <Form.Item name='cpCode' label='Công ty'
                                            rules={[{ required: true, message: 'Vui lòng chọn công ty!' }]}>
                                            <Select
                                                showSearch
                                                placeholder="Chọn công ty"
                                                options={companyOptions}
                                                filterOption={filterOptionByLabel}
                                            />
                                        </Form.Item>
                                        <Form.Item name='bankName' label='Tên ngân hàng'
                                            rules={[{ required: true, message: 'Vui lòng nhập tên ngân hàng!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='accountNumber' label='Số tài khoản'
                                            rules={[{ required: true, message: 'Vui lòng nhập số tài khoản!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='accountName' label='Tên chủ tài khoản'
                                            rules={[{ required: true, message: 'Vui lòng nhập tên chủ tài khoản!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='result' label='Mô tả'>
                                            <Input />
                                        </Form.Item>
                                        <div style={{ textAlign: 'right' }}>
                                            <Button type='primary' htmlType='submit'>Cập nhật</Button>
                                        </div>
                                    </Form>
                                </Modal>
                            </div>
                        ),
                    },
                    {
                        key: 'partnerConfig',
                        label: 'Cấu hình MBH',
                        disabled: !account?.canGetListPartnerConfig,
                        children: (
                            <div>
                                {account?.canAddListPartnerConfig && (
                                    <div style={{ textAlign: 'right', marginBottom: '20px' }}>
                                        <Button onClick={() => setTsOpenModalCreatePartnerConfig(true)}>
                                            Thêm cấu hình
                                        </Button>
                                    </div>
                                )}
                                <CustomTable
                                    namePage='cấu hình'
                                    columns={partnerConfigColumns}
                                    dataSource={partnerConfig?.partners}
                                    total={partnerConfig?.total}
                                    isHiddenPagination={true}
                                />
                                <Modal
                                    title='Thêm tài cấu hình MBH'
                                    open={isOpenModalCreatePartnerConfig}
                                    footer={null}
                                    onCancel={() => setTsOpenModalCreatePartnerConfig(false)}>
                                    <Divider />
                                    <Form form={formCreatePartnerConfig} onFinish={handleCreatePartnerConfig} layout="vertical" autoComplete='off'>
                                        <Form.Item name='cpCode' label='Công ty'
                                            rules={[{ required: true, message: 'Vui lòng chọn công ty!' }]}>
                                            <Select
                                                showSearch
                                                placeholder="Chọn công ty"
                                                options={companyOptions}
                                                filterOption={filterOptionByLabel}
                                            />
                                        </Form.Item>
                                        <Form.Item name='password' label='Mật khẩu'
                                            rules={[{ required: true, message: 'Vui lòng nhập mật khẩu!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='secretKey' label='Secret Key'
                                            rules={[{ required: true, message: 'Vui lòng nhập Secret Key!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='permissions' label='Quyền hạn (method::path::rate::limitedTime)'
                                            rules={[{ required: true, message: 'Vui lòng nhập quyền hạn!' }]}
                                            tooltip="Định dạng: method::path::rate::limitedTime cho create, get, update. Ví dụ: GET::/api/users::100::3600">
                                            <Input.TextArea
                                                rows={4}
                                                placeholder="GET::/api/users::100::3600&#10;POST::/api/users::50::3600&#10;PUT::/api/users::50::3600"
                                            />
                                        </Form.Item>
                                        <Form.Item name='result' label='Mô tả'>
                                            <Input />
                                        </Form.Item>
                                        <div style={{ textAlign: 'right' }}>
                                            <Button type='primary' htmlType='submit'>Thêm</Button>
                                        </div>
                                    </Form>
                                </Modal>
                                <Modal
                                    title='Cập nhật cấu hình MBH'
                                    open={modalUpdatePartnerConfig.isOpen}
                                    footer={null}
                                    onCancel={() => setModalUpdatePartnerConfig({ isOpen: false, data: null })}>
                                    <Divider />
                                    <Form form={formUpdatePartnerConfig} onFinish={handleUpdatePartnerConfig} layout="vertical" autoComplete='off'>
                                        <Form.Item style={{ display: 'none' }} name='sk' />
                                        <Form.Item name='cpCode' label='Công ty'
                                            rules={[{ required: true, message: 'Vui lòng chọn công ty!' }]}>
                                            <Select
                                                showSearch
                                                placeholder="Chọn công ty"
                                                options={companyOptions}
                                                filterOption={filterOptionByLabel}
                                            />
                                        </Form.Item>
                                        <Form.Item name='password' label='Mật khẩu'
                                            rules={[{ required: true, message: 'Vui lòng nhập mật khẩu!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='secretKey' label='Secret Key'
                                            rules={[{ required: true, message: 'Vui lòng nhập Secret Key!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='permissions' label='Quyền hạn (method::path::rate::limitedTime)'
                                            rules={[{ required: true, message: 'Vui lòng nhập quyền hạn!' }]}
                                            tooltip="Định dạng: method::path::rate::limitedTime cho create, get, update. Ví dụ: GET::/api/users::100::3600">
                                            <Input.TextArea
                                                rows={4}
                                                placeholder="GET::/api/users::100::3600&#10;POST::/api/users::50::3600&#10;PUT::/api/users::50::3600"
                                            />
                                        </Form.Item>
                                        <Form.Item name='result' label='Mô tả'>
                                            <Input />
                                        </Form.Item>
                                        <div style={{ textAlign: 'right' }}>
                                            <Button type='primary' htmlType='submit'>Cập nhật</Button>
                                        </div>
                                    </Form>
                                </Modal>
                            </div>
                        ),
                    },
                    {
                        key: 'topUpConfig',
                        label: 'Tài khoản nạp tiền',
                        disabled: !account?.canGetListTopUpConfig,
                        children: (
                            <div>
                                {account?.canAddListTopUpConfig && (
                                    <div style={{ textAlign: 'right', marginBottom: '20px' }}>
                                        <Button onClick={() => setTsOpenModalCreateTopUpConfig(true)}>
                                            Thêm tài khoản
                                        </Button>
                                    </div>
                                )}
                                <CustomTable
                                    namePage='tài khoản'
                                    columns={topUpConfigColumns}
                                    dataSource={topUpConfig?.topUpConfigs}
                                    total={topUpConfig?.total}
                                    isHiddenPagination={true}
                                />
                                <Modal
                                    title='Thêm tài tài khoản nạp tiền'
                                    open={isOpenModalCreateTopUpConfig}
                                    footer={null}
                                    onCancel={() => setTsOpenModalCreateTopUpConfig(false)}>
                                    <Divider />
                                    <Form form={formCreateTopUpConfig} onFinish={handleCreateTopUpConfig} layout="vertical" autoComplete='off'>
                                        <Form.Item name='cpCode' label='Công ty'
                                            rules={[{ required: true, message: 'Vui lòng chọn công ty!' }]}>
                                            <Select
                                                showSearch
                                                placeholder="Chọn công ty"
                                                options={companyOptions}
                                                filterOption={filterOptionByLabel}
                                            />
                                        </Form.Item>
                                        <Form.Item name='network' label='Tên mạng'
                                            rules={[{ required: true, message: 'Vui lòng nhập tên mạng!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='username' label='Tài khoản'
                                            rules={[{ required: true, message: 'Vui lòng nhập tài khoản!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='password' label='Mật khẩu'
                                            rules={[{ required: true, message: 'Vui lòng nhập mật khẩu!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='userId' label='userId'
                                            rules={[{ required: true, message: 'Vui lòng nhập userId!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='rsaPrivateKeyPath' label='rsaPrivateKeyPath'
                                            rules={[{ required: true, message: 'Vui lòng nhập rsaPrivateKeyPath!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='result' label='Mô tả'>
                                            <Input />
                                        </Form.Item>
                                        <div style={{ textAlign: 'right' }}>
                                            <Button type='primary' htmlType='submit'>Thêm</Button>
                                        </div>
                                    </Form>
                                </Modal>
                                <Modal
                                    title='Cập nhật tài khoản nạp tiền'
                                    open={modalUpdateTopUpConfig.isOpen}
                                    footer={null}
                                    onCancel={() => setModalUpdateTopUpConfig({ isOpen: false, data: null })}>
                                    <Divider />
                                    <Form form={formUpdateTopUpConfig} onFinish={handleUpdateTopUpConfig} layout="vertical" autoComplete='off'>
                                        <Form.Item style={{ display: 'none' }} name='sk' />
                                        <Form.Item name='cpCode' label='Công ty'
                                            rules={[{ required: true, message: 'Vui lòng chọn công ty!' }]}>
                                            <Select
                                                showSearch
                                                placeholder="Chọn công ty"
                                                options={companyOptions}
                                                filterOption={filterOptionByLabel}
                                            />
                                        </Form.Item>
                                        <Form.Item name='network' label='Tên mạng'
                                            rules={[{ required: true, message: 'Vui lòng nhập tên mạng!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='username' label='Tài khoản'
                                            rules={[{ required: true, message: 'Vui lòng nhập tài khoản!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='password' label='Mật khẩu'
                                            rules={[{ required: true, message: 'Vui lòng nhập mật khẩu!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='userId' label='userId'
                                            rules={[{ required: true, message: 'Vui lòng nhập userId!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='rsaPrivateKeyPath' label='rsaPrivateKeyPath'
                                            rules={[{ required: true, message: 'Vui lòng nhập rsaPrivateKeyPath!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='result' label='Mô tả'>
                                            <Input />
                                        </Form.Item>
                                        <div style={{ textAlign: 'right' }}>
                                            <Button type='primary' htmlType='submit'>Cập nhật</Button>
                                        </div>
                                    </Form>
                                </Modal>
                            </div>
                        ),
                    },
                    {
                        key: 'invoiceConfig',
                        label: 'Cấu hình hoá đơn',
                        disabled: !account?.canGetListInvoiceConfig,
                        children: (
                            <div>
                                {account?.canAddListInvoiceConfig && (
                                    <div style={{ textAlign: 'right', marginBottom: '20px' }}>
                                        <Button onClick={() => setTsOpenModalCreateInvoiceConfig(true)}>
                                            Thêm cấu hình
                                        </Button>
                                    </div>
                                )}
                                <CustomTable
                                    namePage='cấu hình'
                                    columns={invoiceConfigColumns}
                                    dataSource={invoiceConfig?.invoiceConfigs}
                                    total={invoiceConfig?.total}
                                    isHiddenPagination={true}
                                />
                                <Modal
                                    title='Thêm cấu hình hoá đơn'
                                    open={isOpenModalCreateInvoiceConfig}
                                    footer={null}
                                    onCancel={() => setTsOpenModalCreateInvoiceConfig(false)}>
                                    <Divider />
                                    <Form form={formCreateInvoiceConfig} onFinish={handleCreateInvoiceConfig} layout="vertical" autoComplete='off'>
                                        <Form.Item name='cpCode' label='Công ty'
                                            rules={[{ required: true, message: 'Vui lòng chọn công ty!' }]}>
                                            <Select
                                                showSearch
                                                placeholder="Chọn công ty"
                                                options={companyOptions}
                                                filterOption={filterOptionByLabel}
                                            />
                                        </Form.Item>
                                        <Form.Item style={{ display: 'none' }} name='ownerBy' initialValue={account?.username} />
                                        <Form.Item name='provider' label='Nhà cung cấp'
                                            rules={[{ required: true, message: 'Vui lòng nhập nhà cung cấp!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='network' label='Tên mạng'
                                            rules={[{ required: true, message: 'Vui lòng nhập tên mạng!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='username' label='Tài khoản'
                                            rules={[{ required: true, message: 'Vui lòng nhập tài khoản!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='password' label='Mật khẩu'
                                            rules={[{ required: true, message: 'Vui lòng nhập mật khẩu!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='baseUrl' label='Base URL'
                                            rules={[{ required: true, message: 'Vui lòng nhập Base URL!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='grantType' label='Grant Type'>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='taxCode' label='Tax Code'>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='templateCode' label='Template Code'>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='result' label='Mô tả'>
                                            <Input />
                                        </Form.Item>
                                        <div style={{ textAlign: 'right' }}>
                                            <Button type='primary' htmlType='submit'>Thêm</Button>
                                        </div>
                                    </Form>
                                </Modal>
                                <Modal
                                    title='Cập nhật cấu hình hoá đơn'
                                    open={modalUpdateInvoiceConfig.isOpen}
                                    footer={null}
                                    onCancel={() => setModalUpdateInvoiceConfig({ isOpen: false, data: null })}>
                                    <Divider />
                                    <Form form={formUpdateInvoiceConfig} onFinish={handleUpdateInvoiceConfig} layout="vertical" autoComplete='off'>
                                        <Form.Item style={{ display: 'none' }} name='sk' />
                                        <Form.Item name='cpCode' label='Công ty'
                                            rules={[{ required: true, message: 'Vui lòng chọn công ty!' }]}>
                                            <Select
                                                showSearch
                                                placeholder="Chọn công ty"
                                                options={companyOptions}
                                                filterOption={filterOptionByLabel}
                                            />
                                        </Form.Item>
                                        <Form.Item style={{ display: 'none' }} name='ownerBy' initialValue={account?.username} />
                                        <Form.Item name='provider' label='Nhà cung cấp'
                                            rules={[{ required: true, message: 'Vui lòng nhập nhà cung cấp!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='network' label='Tên mạng'
                                            rules={[{ required: true, message: 'Vui lòng nhập tên mạng!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='username' label='Tài khoản'
                                            rules={[{ required: true, message: 'Vui lòng nhập tài khoản!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='password' label='Mật khẩu'
                                            rules={[{ required: true, message: 'Vui lòng nhập mật khẩu!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='baseUrl' label='Base URL'
                                            rules={[{ required: true, message: 'Vui lòng nhập Base URL!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='grantType' label='Grant Type'>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='taxCode' label='Tax Code'>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='templateCode' label='Template Code'>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='result' label='Mô tả'>
                                            <Input />
                                        </Form.Item>
                                        <div style={{ textAlign: 'right' }}>
                                            <Button type='primary' htmlType='submit'>Cập nhật</Button>
                                        </div>
                                    </Form>
                                </Modal>
                            </div>
                        ),
                    },
                    {
                        key: 'tkgConfig',
                        label: 'Tài khoản API gói',
                        disabled: !account?.canGetListTkgConfig,
                        children: (
                            <div>
                                {account?.canAddListTkgConfig && (
                                    <div style={{ textAlign: 'right', marginBottom: '20px' }}>
                                        <Button onClick={() => setTsOpenModalCreateTkgConfig(true)}>
                                            Thêm tài khoản
                                        </Button>
                                    </div>
                                )}
                                <CustomTable
                                    namePage='tài khoản'
                                    columns={tkgConfigColumns}
                                    dataSource={tkgConfig?.tkgConfigs}
                                    total={tkgConfig?.total}
                                    isHiddenPagination={true}
                                />
                                <Modal
                                    title='Thêm tài khoản API gói'
                                    open={isOpenModalCreateTkgConfig}
                                    footer={null}
                                    onCancel={() => setTsOpenModalCreateTkgConfig(false)}>
                                    <Divider />
                                    <Form form={formCreateTkgConfig} onFinish={handleCreateTkgConfig} layout="vertical" autoComplete='off'>
                                        <Form.Item name='cpCode' label='Công ty'
                                            rules={[{ required: true, message: 'Vui lòng chọn công ty!' }]}>
                                            <Select
                                                showSearch
                                                placeholder="Chọn công ty"
                                                options={companyOptions}
                                                filterOption={filterOptionByLabel}
                                            />
                                        </Form.Item>
                                        <Form.Item name='network' label='Tên mạng'
                                            rules={[{ required: true, message: 'Vui lòng nhập tên mạng!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='username' label='Tài khoản'
                                            rules={[{ required: true, message: 'Vui lòng nhập tài khoản!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='password' label='Mật khẩu'
                                            rules={[{ required: true, message: 'Vui lòng nhập mật khẩu!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='secretKey' label='secretKey'
                                            rules={[{ required: true, message: 'Vui lòng nhập secretKey!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='devStaffCode' label='devStaffCode'
                                            rules={[{ required: true, message: 'Vui lòng nhập devStaffCode!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='result' label='Mô tả'>
                                            <Input />
                                        </Form.Item>
                                        <div style={{ textAlign: 'right' }}>
                                            <Button type='primary' htmlType='submit'>Thêm</Button>
                                        </div>
                                    </Form>
                                </Modal>
                                <Modal
                                    title='Cập nhật tài khoản API gói'
                                    open={modalUpdateTkgConfig.isOpen}
                                    footer={null}
                                    onCancel={() => setModalUpdateTkgConfig({ isOpen: false, data: null })}>
                                    <Divider />
                                    <Form form={formUpdateTkgConfig} onFinish={handleUpdateTkgConfig} layout="vertical" autoComplete='off'>
                                        <Form.Item style={{ display: 'none' }} name='sk' />
                                        <Form.Item name='cpCode' label='Công ty'
                                            rules={[{ required: true, message: 'Vui lòng chọn công ty!' }]}>
                                            <Select
                                                showSearch
                                                placeholder="Chọn công ty"
                                                options={companyOptions}
                                                filterOption={filterOptionByLabel}
                                            />
                                        </Form.Item>
                                        <Form.Item name='network' label='Tên mạng'
                                            rules={[{ required: true, message: 'Vui lòng nhập tên mạng!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='username' label='Tài khoản'
                                            rules={[{ required: true, message: 'Vui lòng nhập tài khoản!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='password' label='Mật khẩu'
                                            rules={[{ required: true, message: 'Vui lòng nhập mật khẩu!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='secretKey' label='secretKey'
                                            rules={[{ required: true, message: 'Vui lòng nhập secretKey!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='devStaffCode' label='devStaffCode'
                                            rules={[{ required: true, message: 'Vui lòng nhập devStaffCode!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='result' label='Mô tả'>
                                            <Input />
                                        </Form.Item>
                                        <div style={{ textAlign: 'right' }}>
                                            <Button type='primary' htmlType='submit'>Cập nhật</Button>
                                        </div>
                                    </Form>
                                </Modal>
                            </div>
                        ),
                    },
                    {
                        key: 'sannConfig',
                        label: 'Cấu hình SANN',
                        disabled: !account?.canGetListSannConfig,
                        children: (
                            <div>
                                {account?.canAddListSannConfig && (
                                    <div style={{ textAlign: 'right', marginBottom: '20px' }}>
                                        <Button onClick={() => setTsOpenModalCreateSannConfig(true)}>
                                            Thêm cấu hình
                                        </Button>
                                    </div>
                                )}
                                <CustomTable
                                    namePage='cấu hình'
                                    columns={sannConfigColumns}
                                    dataSource={sannConfig?.configs}
                                    total={sannConfig?.total}
                                    isHiddenPagination={true}
                                />
                                <Modal
                                    title='Thêm cấu hình SANN'
                                    open={isOpenModalCreateSannConfig}
                                    footer={null}
                                    onCancel={() => setTsOpenModalCreateSannConfig(false)}>
                                    <Divider />
                                    <Form form={formCreateSannConfig} onFinish={handleCreateSannConfig} layout="vertical" autoComplete='off'>
                                        <Form.Item name='cpCode' label='Công ty'
                                            rules={[{ required: true, message: 'Vui lòng chọn công ty!' }]}>
                                            <Select
                                                showSearch
                                                placeholder="Chọn công ty"
                                                options={companyOptions}
                                                filterOption={filterOptionByLabel}
                                            />
                                        </Form.Item>
                                        <Form.Item style={{ display: 'none' }} name='ownerBy' initialValue={account?.username} />
                                        <Form.Item name='network' label='Tên mạng'
                                            rules={[{ required: true, message: 'Vui lòng nhập tên mạng!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='baseUrl' label='Base URL'
                                            rules={[{ required: true, message: 'Vui lòng nhập Base URL!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='password' label='Mật khẩu'
                                            rules={[{ required: true, message: 'Vui lòng nhập mật khẩu!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='proxyAddresses' label='Proxy Addresses'>
                                            <Input.TextArea placeholder="proxy1.example.com,proxy2.example.com" />
                                        </Form.Item>
                                        <Form.Item name='privateKey' label='Private Key'
                                            rules={[{ required: true, message: 'Vui lòng nhập Private Key!' }]}>
                                            <Input.TextArea />
                                        </Form.Item>
                                        <Form.Item name='publicKey' label='Public Key'
                                            rules={[{ required: true, message: 'Vui lòng nhập Public Key!' }]}>
                                            <Input.TextArea />
                                        </Form.Item>
                                        <Form.Item name='result' label='Mô tả'>
                                            <Input.TextArea />
                                        </Form.Item>
                                        <div style={{ textAlign: 'right' }}>
                                            <Button type='primary' htmlType='submit'>Thêm</Button>
                                        </div>
                                    </Form>
                                </Modal>
                                <Modal
                                    title='Cập nhật cấu hình SANN'
                                    open={modalUpdateSannConfig.isOpen}
                                    footer={null}
                                    onCancel={() => setModalUpdateSannConfig({ isOpen: false, data: null })}>
                                    <Divider />
                                    <Form form={formUpdateSannConfig} onFinish={handleUpdateSannConfig} layout="vertical" autoComplete='off'>
                                        <Form.Item style={{ display: 'none' }} name='sk' />
                                        <Form.Item name='cpCode' label='Công ty'
                                            rules={[{ required: true, message: 'Vui lòng chọn công ty!' }]}>
                                            <Select
                                                showSearch
                                                placeholder="Chọn công ty"
                                                options={companyOptions}
                                                filterOption={filterOptionByLabel}
                                            />
                                        </Form.Item>
                                        <Form.Item style={{ display: 'none' }} name='ownerBy' initialValue={account?.username} />
                                        <Form.Item name='network' label='Tên mạng'
                                            rules={[{ required: true, message: 'Vui lòng nhập tên mạng!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='baseUrl' label='Base URL'
                                            rules={[{ required: true, message: 'Vui lòng nhập Base URL!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='password' label='Mật khẩu'
                                            rules={[{ required: true, message: 'Vui lòng nhập mật khẩu!' }]}>
                                            <Input />
                                        </Form.Item>
                                        <Form.Item name='proxyAddresses' label='Proxy Addresses'>
                                            <Input.TextArea placeholder="proxy1.example.com,proxy2.example.com" />
                                        </Form.Item>
                                        <Form.Item name='privateKey' label='Private Key'
                                            rules={[{ required: true, message: 'Vui lòng nhập Private Key!' }]}>
                                            <Input.TextArea />
                                        </Form.Item>
                                        <Form.Item name='publicKey' label='Public Key'
                                            rules={[{ required: true, message: 'Vui lòng nhập Public Key!' }]}>
                                            <Input.TextArea />
                                        </Form.Item>
                                        <Form.Item name='result' label='Mô tả'>
                                            <Input.TextArea />
                                        </Form.Item>
                                        <div style={{ textAlign: 'right' }}>
                                            <Button type='primary' htmlType='submit'>Cập nhật</Button>
                                        </div>
                                    </Form>
                                </Modal>
                            </div>
                        ),
                    },
                ]} />
        </div>
    )
}
